import { Component, Signal, computed, inject } from '@angular/core';
import { ScenicDisplayPage } from '../scenic-display/scenic-display-page';
import { ScreenDatas } from '../../components/screen-datas/screen-datas';
import { LoaderOverlay } from '../../components/loader-overlay/loader-overlay';
import { PauseOverlay } from '../../components/pause-overlay/pause-overlay';
import { Resistance } from '../../components/resistance/resistance';
import { ScreenVideo } from '../../components/screen-video/screen-video';
import { WebSocketService } from '../../services/websocket-service';
import { ApiService } from '../../services/api-service';
import { CoachingIntervalType } from '../../models/coaching-interval.model';
import { IntervalsTimeline } from '../../components/intervals-timeline/intervals-timeline';
import { ChartCurrentSegmentInfo } from '../../components/chart-current-segment-info/chart-current-segment-info';
import { ChartNextSegmentInfo } from '../../components/chart-next-segment-info/chart-next-segment-info';

@Component({
  selector: 'app-coaching-display-page',
  imports: [
    ScreenDatas,
    ScreenVideo,
    Resistance,
    LoaderOverlay,
    PauseOverlay,
    IntervalsTimeline,
    ChartCurrentSegmentInfo,
    ChartNextSegmentInfo,
  ],
  templateUrl: './coaching-display-page.html',
  styleUrl: './coaching-display-page.scss',
  host: {
    '[style.--bg-image]': '`url(${videoInformations()?.thumbnails?.xlarge })`',
  },
})
export class CoachingDisplayPage extends ScenicDisplayPage {
  private readonly coachingApiService: ApiService = inject(ApiService);
  private readonly coachingWebSocketService: WebSocketService = inject(WebSocketService);

  override dataIsLoaded: Signal<boolean> = computed<boolean>(() => {
    return (
      this.videoInformations() !== undefined &&
      this.coachingApiService.coachingIntervals() !== undefined
    );
  });

  protected readonly coachingIntervals: Signal<CoachingIntervalType[]> = computed(
    () => this.coachingApiService.coachingIntervals() ?? [],
  );
  protected readonly currentTime: Signal<number> = computed(
    () => this.coachingWebSocketService.broadcastData()?.data.time ?? 0,
  );
  protected readonly totalDuration: Signal<number> = computed(() => {
    const videoDuration: number = this.videoInformations()?.duration ?? 0;
    const intervals: CoachingIntervalType[] = this.coachingIntervals();
    const lastInterval: CoachingIntervalType | undefined = intervals[intervals.length - 1];
    return videoDuration || (lastInterval ? lastInterval.position + lastInterval.duration : 0);
  });
  protected readonly timelineIsCentered: Signal<boolean> = computed(
    () => this.coachingWebSocketService.config()?.chart === 'center',
  );

  protected override get displaySwitchEnabled(): boolean {
    return false;
  }
}
